import React, { useState, useCallback } from 'react';

import Apply from 'component/Search/Filter/Apply';

import { Feature } from 'config/features';

import { useIntersectionObserver } from 'hooks/useIntersectionObserver';

import FeatureHelper from 'utility/Toggle/Feature';

import Sentinel from './__partials/Sentinel';
import { FILTER_SCROLL_TOP_ID, intersectionObserverOptions } from './config';

import styles from './StickyFilter.module.scss';

interface StickyFilterProps {
    children: React.ReactNode;
    scrollView: React.ReactNode;
}

const StickyFilter = ({ children, scrollView }: StickyFilterProps) => {
    const [render, setRender] = useState(false);
    const observerCallback = useCallback(
        (show: boolean) => {
            const filterList = document.getElementById(FILTER_SCROLL_TOP_ID);
            if (show) {
                const filterHeight = filterList?.getBoundingClientRect().height;
                if (filterList && filterHeight) {
                    filterList.style.minHeight = `${filterHeight}px`;
                }
            } else if (filterList) {
                filterList.style.minHeight = 'auto';
            }
            setRender(show);
        },
        [setRender]
    );
    const filterListRef = useIntersectionObserver(
        intersectionObserverOptions,
        () => observerCallback(false),
        () => observerCallback(true)
    );

    return (
        <>
            <div
                id={FILTER_SCROLL_TOP_ID}
                className={styles.Filter}
                ref={filterListRef}
            >
                {!render && children}
            </div>
            {render && (
                <Sentinel>
                    {scrollView}
                    <FeatureHelper name={Feature.ManualFilterSubmit}>
                        <Apply
                            customClassList={{
                                Button: styles.ApplyButton,
                            }}
                        />
                    </FeatureHelper>
                </Sentinel>
            )}
        </>
    );
};

export default StickyFilter;
